export default function _identity(x) {
  return x;
}


// WEBPACK FOOTER //
// /home/matthewf/Livebetter/node_modules/ramda/es/internal/_identity.js